import {
	useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {useMemo} from "react";
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import {ITaskCreationSingleVoyageMutateVoyage} from "@containers/singleVoyage/mutateVoyage/tasks/types";
import {IPointTemplatesSingleVoyage} from "@containers/singleVoyage/pointTemplates/types";

export function useGetTargetPointMutateSingleVoyage(): {
	targetPoint: IWayPointCreationWithCorrectionsSingleVoyage | null,
	tasks: ITaskCreationSingleVoyageMutateVoyage[],
	numberStop: number | null
} {
	const {
		targetPointId,
		points,
		tasks,
	} = useRootContextMutateSingleVoyage()
	
	return useMemo(() => {
		if (!targetPointId) {
			return {
				targetPoint: null,
				numberStop: null,
				tasks: [],
			}
		}
		const index = points.findIndex((point) => point?.id?.toString() === targetPointId?.toString())
		
		if (index === -1) {
			return {
				targetPoint: null,
				numberStop: null,
				tasks: [],
			}
		}
		const targetPoint = points[index]
		
		const currentTasks = tasks?.filter((task) => {
			if (task?.waypointIds?.includes(Number(targetPoint.id))) {
				return true
			}
			return task?.subtasks?.some((subTask) => subTask?.waypointIds.includes(Number(targetPoint?.id)))
		})
		return {
			targetPoint,
			numberStop: index + 1,
			tasks: currentTasks,
		}
	}, [targetPointId, points, tasks])
}
